"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * inventory
 * Manages inventory caps
 *
 * The version of the OpenAPI document: 1.6.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyDemandSubAccountInventoryCapApi = exports.SupplyDemandSubAccountInventoryCapApiFactory = exports.SupplyDemandSubAccountInventoryCapApiFp = exports.SupplyDemandSubAccountInventoryCapApiAxiosParamCreator = exports.StaticOfferInventoryCapApi = exports.StaticOfferInventoryCapApiFactory = exports.StaticOfferInventoryCapApiFp = exports.StaticOfferInventoryCapApiAxiosParamCreator = exports.DemandSubAccountInventoryCapApi = exports.DemandSubAccountInventoryCapApiFactory = exports.DemandSubAccountInventoryCapApiFp = exports.DemandSubAccountInventoryCapApiAxiosParamCreator = exports.ProductType = exports.CapType = exports.CapEventReason = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * The reason for which this demand sub account or static offer inventory cap event was created.
 * @export
 * @enum {string}
 */
exports.CapEventReason = {
    LeadCapHit: 'LeadCapHit',
    DemandSubAccountClickCapHit: 'DemandSubAccountClickCapHit',
    BudgetCapHit: 'BudgetCapHit',
    ClickCapHit: 'ClickCapHit'
};
/**
 * The type of the inventory cap.  For demand sub account caps, the values `DemandSubAccountClickCap` and `LeadCap` are allowed. For static offer caps, the values `ClickCap` and `BudgetCap` are allowed.
 * @export
 * @enum {string}
 */
exports.CapType = {
    BudgetCap: 'BudgetCap',
    ClickCap: 'ClickCap',
    DemandSubAccountClickCap: 'DemandSubAccountClickCap',
    LeadCap: 'LeadCap'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProductType = {
    CreditCard: 'credit_card',
    Generic: 'generic',
    AutoInsurance: 'auto_insurance',
    Insurance: 'insurance',
    LifeInsurance: 'life_insurance',
    Loan: 'loan',
    Mortgage: 'mortgage',
    Savings: 'savings',
    Other: 'other',
    Unknown: 'unknown'
};
/**
 * DemandSubAccountInventoryCapApi - axios parameter creator
 * @export
 */
var DemandSubAccountInventoryCapApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a demand-sub account inventory cap
         * @summary Create a demand sub-account inventory cap
         * @param {DemandSubAccountInventoryCapCreateData} [demandSubAccountInventoryCapCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandSubAccountInventoryCap: function (demandSubAccountInventoryCapCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([demandSubAccountInventoryCapCreateData_1], args_1, true), void 0, function (demandSubAccountInventoryCapCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandSubAccountInventoryCaps";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandSubAccountInventoryCapCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a demand sub-account inventory cap
         * @summary Delete a demand sub-account inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccountInventoryCap: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDemandSubAccountInventoryCap', 'id', id);
                            localVarPath = "/demandSubAccountInventoryCaps/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create several demand sub-account inventory caps. Respects cap schedule conflicts.
         * @summary Create several demand sub-account inventory caps
         * @param {DemandSubAccountInventoryCapCreateData} [demandSubAccountInventoryCapCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demandSubAccountInventoryCapControllerCreateBulk: function (demandSubAccountInventoryCapCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([demandSubAccountInventoryCapCreateData_1], args_1, true), void 0, function (demandSubAccountInventoryCapCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandSubAccountInventoryCaps/bulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandSubAccountInventoryCapCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return a filtered list of sub-account IDs that have not reached cap limit, given a list of sub-account IDs
         * @summary Filter capped sub-account IDs
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} subAccountIds A comma separated list of SubAccount IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterCappedSubAccountIds: function (limit_1, subAccountIds_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, subAccountIds_1], args_1, true), void 0, function (limit, subAccountIds, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('filterCappedSubAccountIds', 'limit', limit);
                    // verify required parameter 'subAccountIds' is not null or undefined
                    (0, common_1.assertParamExists)('filterCappedSubAccountIds', 'subAccountIds', subAccountIds);
                    localVarPath = "/filterDemandSubAccounts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (subAccountIds) {
                        localVarQueryParameter['subAccountIds'] = subAccountIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get a demand sub-account inventory cap
         * @summary Get a demand sub-account inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountInventoryCap: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandSubAccountInventoryCap', 'id', id);
                            localVarPath = "/demandSubAccountInventoryCaps/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return demand sub account inventory caps based upon request parameters
         * @summary Get demand sub-account inventory caps
         * @param {Array<number>} [id]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<CapType>} [capType]
         * @param {string} [currentDate]
         * @param {Array<ProductType>} [productType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountInventoryCaps: function (id_1, demandSubAccountId_1, capType_1, currentDate_1, productType_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, demandSubAccountId_1, capType_1, currentDate_1, productType_1], args_1, true), void 0, function (id, demandSubAccountId, capType, currentDate, productType, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandSubAccountInventoryCaps";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId;
                            }
                            if (capType) {
                                localVarQueryParameter['capType'] = capType;
                            }
                            if (currentDate !== undefined) {
                                localVarQueryParameter['currentDate'] = (currentDate instanceof Date) ?
                                    currentDate.toISOString().substring(0, 10) :
                                    currentDate;
                            }
                            if (productType) {
                                localVarQueryParameter['productType'] = productType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Refresh `DemandSubAccountInventoryCaps` cache manually
         * @summary Refresh demand sub-account inventory cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshDemandSubAccountInventoryCache: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/calculateDemandSubAccountCaps";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update a demand sub0-account inventory cap
         * @summary Update a demand sub-account inventory cap
         * @param {number} id
         * @param {DemandSubAccountInventoryCapUpdateData} [demandSubAccountInventoryCapUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDemandSubAccountInventoryCap: function (id_1, demandSubAccountInventoryCapUpdateData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, demandSubAccountInventoryCapUpdateData_1], args_1, true), void 0, function (id, demandSubAccountInventoryCapUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updateDemandSubAccountInventoryCap', 'id', id);
                            localVarPath = "/demandSubAccountInventoryCaps/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandSubAccountInventoryCapUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DemandSubAccountInventoryCapApiAxiosParamCreator = DemandSubAccountInventoryCapApiAxiosParamCreator;
/**
 * DemandSubAccountInventoryCapApi - functional programming interface
 * @export
 */
var DemandSubAccountInventoryCapApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DemandSubAccountInventoryCapApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a demand-sub account inventory cap
         * @summary Create a demand sub-account inventory cap
         * @param {DemandSubAccountInventoryCapCreateData} [demandSubAccountInventoryCapCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandSubAccountInventoryCap: function (demandSubAccountInventoryCapCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDemandSubAccountInventoryCap(demandSubAccountInventoryCapCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountInventoryCapApi.createDemandSubAccountInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a demand sub-account inventory cap
         * @summary Delete a demand sub-account inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccountInventoryCap: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDemandSubAccountInventoryCap(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountInventoryCapApi.deleteDemandSubAccountInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create several demand sub-account inventory caps. Respects cap schedule conflicts.
         * @summary Create several demand sub-account inventory caps
         * @param {DemandSubAccountInventoryCapCreateData} [demandSubAccountInventoryCapCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demandSubAccountInventoryCapControllerCreateBulk: function (demandSubAccountInventoryCapCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.demandSubAccountInventoryCapControllerCreateBulk(demandSubAccountInventoryCapCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountInventoryCapApi.demandSubAccountInventoryCapControllerCreateBulk']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return a filtered list of sub-account IDs that have not reached cap limit, given a list of sub-account IDs
         * @summary Filter capped sub-account IDs
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} subAccountIds A comma separated list of SubAccount IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterCappedSubAccountIds: function (limit, subAccountIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filterCappedSubAccountIds(limit, subAccountIds, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountInventoryCapApi.filterCappedSubAccountIds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a demand sub-account inventory cap
         * @summary Get a demand sub-account inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountInventoryCap: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandSubAccountInventoryCap(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountInventoryCapApi.getDemandSubAccountInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return demand sub account inventory caps based upon request parameters
         * @summary Get demand sub-account inventory caps
         * @param {Array<number>} [id]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<CapType>} [capType]
         * @param {string} [currentDate]
         * @param {Array<ProductType>} [productType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountInventoryCaps: function (id, demandSubAccountId, capType, currentDate, productType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandSubAccountInventoryCaps(id, demandSubAccountId, capType, currentDate, productType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountInventoryCapApi.getDemandSubAccountInventoryCaps']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Refresh `DemandSubAccountInventoryCaps` cache manually
         * @summary Refresh demand sub-account inventory cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshDemandSubAccountInventoryCache: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refreshDemandSubAccountInventoryCache(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountInventoryCapApi.refreshDemandSubAccountInventoryCache']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update a demand sub0-account inventory cap
         * @summary Update a demand sub-account inventory cap
         * @param {number} id
         * @param {DemandSubAccountInventoryCapUpdateData} [demandSubAccountInventoryCapUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDemandSubAccountInventoryCap: function (id, demandSubAccountInventoryCapUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDemandSubAccountInventoryCap(id, demandSubAccountInventoryCapUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountInventoryCapApi.updateDemandSubAccountInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DemandSubAccountInventoryCapApiFp = DemandSubAccountInventoryCapApiFp;
/**
 * DemandSubAccountInventoryCapApi - factory interface
 * @export
 */
var DemandSubAccountInventoryCapApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DemandSubAccountInventoryCapApiFp)(configuration);
    return {
        /**
         * Create a demand-sub account inventory cap
         * @summary Create a demand sub-account inventory cap
         * @param {DemandSubAccountInventoryCapApiCreateDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandSubAccountInventoryCap: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createDemandSubAccountInventoryCap(requestParameters.demandSubAccountInventoryCapCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a demand sub-account inventory cap
         * @summary Delete a demand sub-account inventory cap
         * @param {DemandSubAccountInventoryCapApiDeleteDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccountInventoryCap: function (requestParameters, options) {
            return localVarFp.deleteDemandSubAccountInventoryCap(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create several demand sub-account inventory caps. Respects cap schedule conflicts.
         * @summary Create several demand sub-account inventory caps
         * @param {DemandSubAccountInventoryCapApiDemandSubAccountInventoryCapControllerCreateBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demandSubAccountInventoryCapControllerCreateBulk: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.demandSubAccountInventoryCapControllerCreateBulk(requestParameters.demandSubAccountInventoryCapCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return a filtered list of sub-account IDs that have not reached cap limit, given a list of sub-account IDs
         * @summary Filter capped sub-account IDs
         * @param {DemandSubAccountInventoryCapApiFilterCappedSubAccountIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterCappedSubAccountIds: function (requestParameters, options) {
            return localVarFp.filterCappedSubAccountIds(requestParameters.limit, requestParameters.subAccountIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a demand sub-account inventory cap
         * @summary Get a demand sub-account inventory cap
         * @param {DemandSubAccountInventoryCapApiGetDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountInventoryCap: function (requestParameters, options) {
            return localVarFp.getDemandSubAccountInventoryCap(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return demand sub account inventory caps based upon request parameters
         * @summary Get demand sub-account inventory caps
         * @param {DemandSubAccountInventoryCapApiGetDemandSubAccountInventoryCapsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountInventoryCaps: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getDemandSubAccountInventoryCaps(requestParameters.id, requestParameters.demandSubAccountId, requestParameters.capType, requestParameters.currentDate, requestParameters.productType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Refresh `DemandSubAccountInventoryCaps` cache manually
         * @summary Refresh demand sub-account inventory cache
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshDemandSubAccountInventoryCache: function (options) {
            return localVarFp.refreshDemandSubAccountInventoryCache(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a demand sub0-account inventory cap
         * @summary Update a demand sub-account inventory cap
         * @param {DemandSubAccountInventoryCapApiUpdateDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDemandSubAccountInventoryCap: function (requestParameters, options) {
            return localVarFp.updateDemandSubAccountInventoryCap(requestParameters.id, requestParameters.demandSubAccountInventoryCapUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DemandSubAccountInventoryCapApiFactory = DemandSubAccountInventoryCapApiFactory;
/**
 * DemandSubAccountInventoryCapApi - object-oriented interface
 * @export
 * @class DemandSubAccountInventoryCapApi
 * @extends {BaseAPI}
 */
var DemandSubAccountInventoryCapApi = /** @class */ (function (_super) {
    __extends(DemandSubAccountInventoryCapApi, _super);
    function DemandSubAccountInventoryCapApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a demand-sub account inventory cap
     * @summary Create a demand sub-account inventory cap
     * @param {DemandSubAccountInventoryCapApiCreateDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountInventoryCapApi
     */
    DemandSubAccountInventoryCapApi.prototype.createDemandSubAccountInventoryCap = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DemandSubAccountInventoryCapApiFp)(this.configuration).createDemandSubAccountInventoryCap(requestParameters.demandSubAccountInventoryCapCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a demand sub-account inventory cap
     * @summary Delete a demand sub-account inventory cap
     * @param {DemandSubAccountInventoryCapApiDeleteDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountInventoryCapApi
     */
    DemandSubAccountInventoryCapApi.prototype.deleteDemandSubAccountInventoryCap = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandSubAccountInventoryCapApiFp)(this.configuration).deleteDemandSubAccountInventoryCap(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create several demand sub-account inventory caps. Respects cap schedule conflicts.
     * @summary Create several demand sub-account inventory caps
     * @param {DemandSubAccountInventoryCapApiDemandSubAccountInventoryCapControllerCreateBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountInventoryCapApi
     */
    DemandSubAccountInventoryCapApi.prototype.demandSubAccountInventoryCapControllerCreateBulk = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DemandSubAccountInventoryCapApiFp)(this.configuration).demandSubAccountInventoryCapControllerCreateBulk(requestParameters.demandSubAccountInventoryCapCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return a filtered list of sub-account IDs that have not reached cap limit, given a list of sub-account IDs
     * @summary Filter capped sub-account IDs
     * @param {DemandSubAccountInventoryCapApiFilterCappedSubAccountIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountInventoryCapApi
     */
    DemandSubAccountInventoryCapApi.prototype.filterCappedSubAccountIds = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandSubAccountInventoryCapApiFp)(this.configuration).filterCappedSubAccountIds(requestParameters.limit, requestParameters.subAccountIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a demand sub-account inventory cap
     * @summary Get a demand sub-account inventory cap
     * @param {DemandSubAccountInventoryCapApiGetDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountInventoryCapApi
     */
    DemandSubAccountInventoryCapApi.prototype.getDemandSubAccountInventoryCap = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandSubAccountInventoryCapApiFp)(this.configuration).getDemandSubAccountInventoryCap(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return demand sub account inventory caps based upon request parameters
     * @summary Get demand sub-account inventory caps
     * @param {DemandSubAccountInventoryCapApiGetDemandSubAccountInventoryCapsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountInventoryCapApi
     */
    DemandSubAccountInventoryCapApi.prototype.getDemandSubAccountInventoryCaps = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DemandSubAccountInventoryCapApiFp)(this.configuration).getDemandSubAccountInventoryCaps(requestParameters.id, requestParameters.demandSubAccountId, requestParameters.capType, requestParameters.currentDate, requestParameters.productType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Refresh `DemandSubAccountInventoryCaps` cache manually
     * @summary Refresh demand sub-account inventory cache
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountInventoryCapApi
     */
    DemandSubAccountInventoryCapApi.prototype.refreshDemandSubAccountInventoryCache = function (options) {
        var _this = this;
        return (0, exports.DemandSubAccountInventoryCapApiFp)(this.configuration).refreshDemandSubAccountInventoryCache(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a demand sub0-account inventory cap
     * @summary Update a demand sub-account inventory cap
     * @param {DemandSubAccountInventoryCapApiUpdateDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountInventoryCapApi
     */
    DemandSubAccountInventoryCapApi.prototype.updateDemandSubAccountInventoryCap = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandSubAccountInventoryCapApiFp)(this.configuration).updateDemandSubAccountInventoryCap(requestParameters.id, requestParameters.demandSubAccountInventoryCapUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DemandSubAccountInventoryCapApi;
}(base_1.BaseAPI));
exports.DemandSubAccountInventoryCapApi = DemandSubAccountInventoryCapApi;
/**
 * StaticOfferInventoryCapApi - axios parameter creator
 * @export
 */
var StaticOfferInventoryCapApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * create a static offer inventory cap
         * @summary Create a static offer inventory cap
         * @param {StaticOfferInventoryCapCreateData} [staticOfferInventoryCapCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticOfferInventoryCap: function (staticOfferInventoryCapCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([staticOfferInventoryCapCreateData_1], args_1, true), void 0, function (staticOfferInventoryCapCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/staticOfferInventoryCaps";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(staticOfferInventoryCapCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a static offer inventory cap
         * @summary Delete a static offer inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticOfferInventoryCap: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteStaticOfferInventoryCap', 'id', id);
                            localVarPath = "/staticOfferInventoryCaps/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a static offer inventory cap
         * @summary Get a static offer inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCap: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getStaticOfferInventoryCap', 'id', id);
                            localVarPath = "/staticOfferInventoryCaps/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get the status of a static offer invetory cap
         * @summary Get the status of a static offer invetory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCapStatus: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getStaticOfferInventoryCapStatus', 'id', id);
                            localVarPath = "/staticOfferInventoryCapsStatus/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get static offer inventory cap statuses
         * @summary Get static offer inventory cap statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCapStatuses: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/staticOfferInvetoryCapsStatuses";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a version diff of a static offer inventory cap
         * @summary Get a version diff of a static offer inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCapVersionDiff: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getStaticOfferInventoryCapVersionDiff', 'id', id);
                            localVarPath = "/staticOfferInventoryCaps/{id}/versionDiff"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return a list of StaticOfferInventoryCaps, filtered by search criteria provided in the URL
         * @summary Get static offer inventory caps
         * @param {Array<number>} [id] A comma separated list of StaticOfferInventoryCap ids
         * @param {Array<number>} [staticOfferId] A comma separated list of StaticOffer ids
         * @param {Array<number>} [subAccountId] A comma separated list of SubAccount ids
         * @param {Array<CapType>} [capType]
         * @param {Array<ProductType>} [productType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCaps: function (id_1, staticOfferId_1, subAccountId_1, capType_1, productType_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, staticOfferId_1, subAccountId_1, capType_1, productType_1], args_1, true), void 0, function (id, staticOfferId, subAccountId, capType, productType, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/staticOfferInventoryCaps";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (staticOfferId) {
                                localVarQueryParameter['staticOfferId'] = staticOfferId;
                            }
                            if (subAccountId) {
                                localVarQueryParameter['subAccountId'] = subAccountId;
                            }
                            if (capType) {
                                localVarQueryParameter['capType'] = capType;
                            }
                            if (productType) {
                                localVarQueryParameter['productType'] = productType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a static offer inventory cap
         * @summary Update a static offer inventory cap
         * @param {number} id
         * @param {StaticOfferInventoryCapUpdateData} [staticOfferInventoryCapUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaticOfferInventoryCap: function (id_1, staticOfferInventoryCapUpdateData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, staticOfferInventoryCapUpdateData_1], args_1, true), void 0, function (id, staticOfferInventoryCapUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updateStaticOfferInventoryCap', 'id', id);
                            localVarPath = "/staticOfferInventoryCaps/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(staticOfferInventoryCapUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.StaticOfferInventoryCapApiAxiosParamCreator = StaticOfferInventoryCapApiAxiosParamCreator;
/**
 * StaticOfferInventoryCapApi - functional programming interface
 * @export
 */
var StaticOfferInventoryCapApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.StaticOfferInventoryCapApiAxiosParamCreator)(configuration);
    return {
        /**
         * create a static offer inventory cap
         * @summary Create a static offer inventory cap
         * @param {StaticOfferInventoryCapCreateData} [staticOfferInventoryCapCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticOfferInventoryCap: function (staticOfferInventoryCapCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createStaticOfferInventoryCap(staticOfferInventoryCapCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferInventoryCapApi.createStaticOfferInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a static offer inventory cap
         * @summary Delete a static offer inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticOfferInventoryCap: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteStaticOfferInventoryCap(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferInventoryCapApi.deleteStaticOfferInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a static offer inventory cap
         * @summary Get a static offer inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCap: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStaticOfferInventoryCap(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferInventoryCapApi.getStaticOfferInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get the status of a static offer invetory cap
         * @summary Get the status of a static offer invetory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCapStatus: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStaticOfferInventoryCapStatus(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferInventoryCapApi.getStaticOfferInventoryCapStatus']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get static offer inventory cap statuses
         * @summary Get static offer inventory cap statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCapStatuses: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStaticOfferInventoryCapStatuses(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferInventoryCapApi.getStaticOfferInventoryCapStatuses']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a version diff of a static offer inventory cap
         * @summary Get a version diff of a static offer inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCapVersionDiff: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStaticOfferInventoryCapVersionDiff(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferInventoryCapApi.getStaticOfferInventoryCapVersionDiff']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return a list of StaticOfferInventoryCaps, filtered by search criteria provided in the URL
         * @summary Get static offer inventory caps
         * @param {Array<number>} [id] A comma separated list of StaticOfferInventoryCap ids
         * @param {Array<number>} [staticOfferId] A comma separated list of StaticOffer ids
         * @param {Array<number>} [subAccountId] A comma separated list of SubAccount ids
         * @param {Array<CapType>} [capType]
         * @param {Array<ProductType>} [productType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCaps: function (id, staticOfferId, subAccountId, capType, productType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStaticOfferInventoryCaps(id, staticOfferId, subAccountId, capType, productType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferInventoryCapApi.getStaticOfferInventoryCaps']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update a static offer inventory cap
         * @summary Update a static offer inventory cap
         * @param {number} id
         * @param {StaticOfferInventoryCapUpdateData} [staticOfferInventoryCapUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaticOfferInventoryCap: function (id, staticOfferInventoryCapUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateStaticOfferInventoryCap(id, staticOfferInventoryCapUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['StaticOfferInventoryCapApi.updateStaticOfferInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.StaticOfferInventoryCapApiFp = StaticOfferInventoryCapApiFp;
/**
 * StaticOfferInventoryCapApi - factory interface
 * @export
 */
var StaticOfferInventoryCapApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.StaticOfferInventoryCapApiFp)(configuration);
    return {
        /**
         * create a static offer inventory cap
         * @summary Create a static offer inventory cap
         * @param {StaticOfferInventoryCapApiCreateStaticOfferInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStaticOfferInventoryCap: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createStaticOfferInventoryCap(requestParameters.staticOfferInventoryCapCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a static offer inventory cap
         * @summary Delete a static offer inventory cap
         * @param {StaticOfferInventoryCapApiDeleteStaticOfferInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStaticOfferInventoryCap: function (requestParameters, options) {
            return localVarFp.deleteStaticOfferInventoryCap(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a static offer inventory cap
         * @summary Get a static offer inventory cap
         * @param {StaticOfferInventoryCapApiGetStaticOfferInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCap: function (requestParameters, options) {
            return localVarFp.getStaticOfferInventoryCap(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the status of a static offer invetory cap
         * @summary Get the status of a static offer invetory cap
         * @param {StaticOfferInventoryCapApiGetStaticOfferInventoryCapStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCapStatus: function (requestParameters, options) {
            return localVarFp.getStaticOfferInventoryCapStatus(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get static offer inventory cap statuses
         * @summary Get static offer inventory cap statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCapStatuses: function (options) {
            return localVarFp.getStaticOfferInventoryCapStatuses(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a version diff of a static offer inventory cap
         * @summary Get a version diff of a static offer inventory cap
         * @param {StaticOfferInventoryCapApiGetStaticOfferInventoryCapVersionDiffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCapVersionDiff: function (requestParameters, options) {
            return localVarFp.getStaticOfferInventoryCapVersionDiff(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return a list of StaticOfferInventoryCaps, filtered by search criteria provided in the URL
         * @summary Get static offer inventory caps
         * @param {StaticOfferInventoryCapApiGetStaticOfferInventoryCapsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticOfferInventoryCaps: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getStaticOfferInventoryCaps(requestParameters.id, requestParameters.staticOfferId, requestParameters.subAccountId, requestParameters.capType, requestParameters.productType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a static offer inventory cap
         * @summary Update a static offer inventory cap
         * @param {StaticOfferInventoryCapApiUpdateStaticOfferInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStaticOfferInventoryCap: function (requestParameters, options) {
            return localVarFp.updateStaticOfferInventoryCap(requestParameters.id, requestParameters.staticOfferInventoryCapUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.StaticOfferInventoryCapApiFactory = StaticOfferInventoryCapApiFactory;
/**
 * StaticOfferInventoryCapApi - object-oriented interface
 * @export
 * @class StaticOfferInventoryCapApi
 * @extends {BaseAPI}
 */
var StaticOfferInventoryCapApi = /** @class */ (function (_super) {
    __extends(StaticOfferInventoryCapApi, _super);
    function StaticOfferInventoryCapApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * create a static offer inventory cap
     * @summary Create a static offer inventory cap
     * @param {StaticOfferInventoryCapApiCreateStaticOfferInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferInventoryCapApi
     */
    StaticOfferInventoryCapApi.prototype.createStaticOfferInventoryCap = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.StaticOfferInventoryCapApiFp)(this.configuration).createStaticOfferInventoryCap(requestParameters.staticOfferInventoryCapCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a static offer inventory cap
     * @summary Delete a static offer inventory cap
     * @param {StaticOfferInventoryCapApiDeleteStaticOfferInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferInventoryCapApi
     */
    StaticOfferInventoryCapApi.prototype.deleteStaticOfferInventoryCap = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaticOfferInventoryCapApiFp)(this.configuration).deleteStaticOfferInventoryCap(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a static offer inventory cap
     * @summary Get a static offer inventory cap
     * @param {StaticOfferInventoryCapApiGetStaticOfferInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferInventoryCapApi
     */
    StaticOfferInventoryCapApi.prototype.getStaticOfferInventoryCap = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaticOfferInventoryCapApiFp)(this.configuration).getStaticOfferInventoryCap(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the status of a static offer invetory cap
     * @summary Get the status of a static offer invetory cap
     * @param {StaticOfferInventoryCapApiGetStaticOfferInventoryCapStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferInventoryCapApi
     */
    StaticOfferInventoryCapApi.prototype.getStaticOfferInventoryCapStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaticOfferInventoryCapApiFp)(this.configuration).getStaticOfferInventoryCapStatus(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get static offer inventory cap statuses
     * @summary Get static offer inventory cap statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferInventoryCapApi
     */
    StaticOfferInventoryCapApi.prototype.getStaticOfferInventoryCapStatuses = function (options) {
        var _this = this;
        return (0, exports.StaticOfferInventoryCapApiFp)(this.configuration).getStaticOfferInventoryCapStatuses(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a version diff of a static offer inventory cap
     * @summary Get a version diff of a static offer inventory cap
     * @param {StaticOfferInventoryCapApiGetStaticOfferInventoryCapVersionDiffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferInventoryCapApi
     */
    StaticOfferInventoryCapApi.prototype.getStaticOfferInventoryCapVersionDiff = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaticOfferInventoryCapApiFp)(this.configuration).getStaticOfferInventoryCapVersionDiff(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return a list of StaticOfferInventoryCaps, filtered by search criteria provided in the URL
     * @summary Get static offer inventory caps
     * @param {StaticOfferInventoryCapApiGetStaticOfferInventoryCapsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferInventoryCapApi
     */
    StaticOfferInventoryCapApi.prototype.getStaticOfferInventoryCaps = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.StaticOfferInventoryCapApiFp)(this.configuration).getStaticOfferInventoryCaps(requestParameters.id, requestParameters.staticOfferId, requestParameters.subAccountId, requestParameters.capType, requestParameters.productType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a static offer inventory cap
     * @summary Update a static offer inventory cap
     * @param {StaticOfferInventoryCapApiUpdateStaticOfferInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticOfferInventoryCapApi
     */
    StaticOfferInventoryCapApi.prototype.updateStaticOfferInventoryCap = function (requestParameters, options) {
        var _this = this;
        return (0, exports.StaticOfferInventoryCapApiFp)(this.configuration).updateStaticOfferInventoryCap(requestParameters.id, requestParameters.staticOfferInventoryCapUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StaticOfferInventoryCapApi;
}(base_1.BaseAPI));
exports.StaticOfferInventoryCapApi = StaticOfferInventoryCapApi;
/**
 * SupplyDemandSubAccountInventoryCapApi - axios parameter creator
 * @export
 */
var SupplyDemandSubAccountInventoryCapApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create several supply/demand sub-account inventory caps. Respects cap schedule conflicts.
         * @summary Create several supply/demand sub-account inventory caps
         * @param {SupplyDemandSubAccountInventoryCapCreateData} [supplyDemandSubAccountInventoryCapCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkSupplyDemandSubAccountInventoryCap: function (supplyDemandSubAccountInventoryCapCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplyDemandSubAccountInventoryCapCreateData_1], args_1, true), void 0, function (supplyDemandSubAccountInventoryCapCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplyDemandSubAccountInventoryCaps/bulk";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyDemandSubAccountInventoryCapCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a supply/demand sub-account inventory cap
         * @summary Create a supply/demand sub-account inventory cap
         * @param {SupplyDemandSubAccountInventoryCapCreateData} [supplyDemandSubAccountInventoryCapCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyDemandSubAccountInventoryCap: function (supplyDemandSubAccountInventoryCapCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplyDemandSubAccountInventoryCapCreateData_1], args_1, true), void 0, function (supplyDemandSubAccountInventoryCapCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplyDemandSubAccountInventoryCaps";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyDemandSubAccountInventoryCapCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a supply/demand sub-account inventory cap
         * @summary Delete a supply/demand sub-account inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyDemandSubAccountInventoryCap: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplyDemandSubAccountInventoryCap', 'id', id);
                            localVarPath = "/supplyDemandSubAccountInventoryCaps/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return a filtered list of sub-account IDs that have not reached cap limit, given a list of sub-account IDs
         * @summary Filter capped sub-account IDs
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} demandSubAccountIds A comma separated list of Demand SubAccount IDs
         * @param {number} supplySubAccountId A SubAccount ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterSupplyDemandCappedSubAccountIds: function (limit_1, demandSubAccountIds_1, supplySubAccountId_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, demandSubAccountIds_1, supplySubAccountId_1], args_1, true), void 0, function (limit, demandSubAccountIds, supplySubAccountId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'limit' is not null or undefined
                    (0, common_1.assertParamExists)('filterSupplyDemandCappedSubAccountIds', 'limit', limit);
                    // verify required parameter 'demandSubAccountIds' is not null or undefined
                    (0, common_1.assertParamExists)('filterSupplyDemandCappedSubAccountIds', 'demandSubAccountIds', demandSubAccountIds);
                    // verify required parameter 'supplySubAccountId' is not null or undefined
                    (0, common_1.assertParamExists)('filterSupplyDemandCappedSubAccountIds', 'supplySubAccountId', supplySubAccountId);
                    localVarPath = "/filterSupplyDemandSubAccounts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (demandSubAccountIds) {
                        localVarQueryParameter['demandSubAccountIds'] = demandSubAccountIds;
                    }
                    if (supplySubAccountId !== undefined) {
                        localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get a supply/demand sub-account inventory cap
         * @summary Get a supply/demand sub-account inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandSubAccountInventoryCap: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplyDemandSubAccountInventoryCap', 'id', id);
                            localVarPath = "/supplyDemandSubAccountInventoryCaps/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return supply/demand sub-account inventory caps based upon request parameters
         * @summary Get supply/demand sub-account inventory caps
         * @param {Array<number>} [id]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<CapType>} [capType]
         * @param {string} [currentDate]
         * @param {Array<ProductType>} [productType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandSubAccountInventoryCaps: function (id_1, supplySubAccountId_1, demandSubAccountId_1, capType_1, currentDate_1, productType_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, supplySubAccountId_1, demandSubAccountId_1, capType_1, currentDate_1, productType_1], args_1, true), void 0, function (id, supplySubAccountId, demandSubAccountId, capType, currentDate, productType, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplyDemandSubAccountInventoryCaps";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId;
                            }
                            if (capType) {
                                localVarQueryParameter['capType'] = capType;
                            }
                            if (currentDate !== undefined) {
                                localVarQueryParameter['currentDate'] = (currentDate instanceof Date) ?
                                    currentDate.toISOString().substring(0, 10) :
                                    currentDate;
                            }
                            if (productType) {
                                localVarQueryParameter['productType'] = productType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update a supply/demand sub-account inventory cap
         * @summary Update a supply/demand sub-account inventory cap
         * @param {number} id
         * @param {SupplyDemandSubAccountInventoryCapUpdateData} [supplyDemandSubAccountInventoryCapUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplyDemandSubAccountInventoryCap: function (id_1, supplyDemandSubAccountInventoryCapUpdateData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, supplyDemandSubAccountInventoryCapUpdateData_1], args_1, true), void 0, function (id, supplyDemandSubAccountInventoryCapUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updateSupplyDemandSubAccountInventoryCap', 'id', id);
                            localVarPath = "/supplyDemandSubAccountInventoryCaps/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["inventory:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyDemandSubAccountInventoryCapUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupplyDemandSubAccountInventoryCapApiAxiosParamCreator = SupplyDemandSubAccountInventoryCapApiAxiosParamCreator;
/**
 * SupplyDemandSubAccountInventoryCapApi - functional programming interface
 * @export
 */
var SupplyDemandSubAccountInventoryCapApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupplyDemandSubAccountInventoryCapApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create several supply/demand sub-account inventory caps. Respects cap schedule conflicts.
         * @summary Create several supply/demand sub-account inventory caps
         * @param {SupplyDemandSubAccountInventoryCapCreateData} [supplyDemandSubAccountInventoryCapCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkSupplyDemandSubAccountInventoryCap: function (supplyDemandSubAccountInventoryCapCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBulkSupplyDemandSubAccountInventoryCap(supplyDemandSubAccountInventoryCapCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyDemandSubAccountInventoryCapApi.createBulkSupplyDemandSubAccountInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a supply/demand sub-account inventory cap
         * @summary Create a supply/demand sub-account inventory cap
         * @param {SupplyDemandSubAccountInventoryCapCreateData} [supplyDemandSubAccountInventoryCapCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyDemandSubAccountInventoryCap: function (supplyDemandSubAccountInventoryCapCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplyDemandSubAccountInventoryCap(supplyDemandSubAccountInventoryCapCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyDemandSubAccountInventoryCapApi.createSupplyDemandSubAccountInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a supply/demand sub-account inventory cap
         * @summary Delete a supply/demand sub-account inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyDemandSubAccountInventoryCap: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplyDemandSubAccountInventoryCap(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyDemandSubAccountInventoryCapApi.deleteSupplyDemandSubAccountInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return a filtered list of sub-account IDs that have not reached cap limit, given a list of sub-account IDs
         * @summary Filter capped sub-account IDs
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} demandSubAccountIds A comma separated list of Demand SubAccount IDs
         * @param {number} supplySubAccountId A SubAccount ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterSupplyDemandCappedSubAccountIds: function (limit, demandSubAccountIds, supplySubAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.filterSupplyDemandCappedSubAccountIds(limit, demandSubAccountIds, supplySubAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyDemandSubAccountInventoryCapApi.filterSupplyDemandCappedSubAccountIds']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a supply/demand sub-account inventory cap
         * @summary Get a supply/demand sub-account inventory cap
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandSubAccountInventoryCap: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplyDemandSubAccountInventoryCap(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyDemandSubAccountInventoryCapApi.getSupplyDemandSubAccountInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return supply/demand sub-account inventory caps based upon request parameters
         * @summary Get supply/demand sub-account inventory caps
         * @param {Array<number>} [id]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<CapType>} [capType]
         * @param {string} [currentDate]
         * @param {Array<ProductType>} [productType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandSubAccountInventoryCaps: function (id, supplySubAccountId, demandSubAccountId, capType, currentDate, productType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplyDemandSubAccountInventoryCaps(id, supplySubAccountId, demandSubAccountId, capType, currentDate, productType, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyDemandSubAccountInventoryCapApi.getSupplyDemandSubAccountInventoryCaps']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update a supply/demand sub-account inventory cap
         * @summary Update a supply/demand sub-account inventory cap
         * @param {number} id
         * @param {SupplyDemandSubAccountInventoryCapUpdateData} [supplyDemandSubAccountInventoryCapUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplyDemandSubAccountInventoryCap: function (id, supplyDemandSubAccountInventoryCapUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSupplyDemandSubAccountInventoryCap(id, supplyDemandSubAccountInventoryCapUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyDemandSubAccountInventoryCapApi.updateSupplyDemandSubAccountInventoryCap']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SupplyDemandSubAccountInventoryCapApiFp = SupplyDemandSubAccountInventoryCapApiFp;
/**
 * SupplyDemandSubAccountInventoryCapApi - factory interface
 * @export
 */
var SupplyDemandSubAccountInventoryCapApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupplyDemandSubAccountInventoryCapApiFp)(configuration);
    return {
        /**
         * Create several supply/demand sub-account inventory caps. Respects cap schedule conflicts.
         * @summary Create several supply/demand sub-account inventory caps
         * @param {SupplyDemandSubAccountInventoryCapApiCreateBulkSupplyDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkSupplyDemandSubAccountInventoryCap: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createBulkSupplyDemandSubAccountInventoryCap(requestParameters.supplyDemandSubAccountInventoryCapCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a supply/demand sub-account inventory cap
         * @summary Create a supply/demand sub-account inventory cap
         * @param {SupplyDemandSubAccountInventoryCapApiCreateSupplyDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyDemandSubAccountInventoryCap: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSupplyDemandSubAccountInventoryCap(requestParameters.supplyDemandSubAccountInventoryCapCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a supply/demand sub-account inventory cap
         * @summary Delete a supply/demand sub-account inventory cap
         * @param {SupplyDemandSubAccountInventoryCapApiDeleteSupplyDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyDemandSubAccountInventoryCap: function (requestParameters, options) {
            return localVarFp.deleteSupplyDemandSubAccountInventoryCap(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return a filtered list of sub-account IDs that have not reached cap limit, given a list of sub-account IDs
         * @summary Filter capped sub-account IDs
         * @param {SupplyDemandSubAccountInventoryCapApiFilterSupplyDemandCappedSubAccountIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterSupplyDemandCappedSubAccountIds: function (requestParameters, options) {
            return localVarFp.filterSupplyDemandCappedSubAccountIds(requestParameters.limit, requestParameters.demandSubAccountIds, requestParameters.supplySubAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a supply/demand sub-account inventory cap
         * @summary Get a supply/demand sub-account inventory cap
         * @param {SupplyDemandSubAccountInventoryCapApiGetSupplyDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandSubAccountInventoryCap: function (requestParameters, options) {
            return localVarFp.getSupplyDemandSubAccountInventoryCap(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return supply/demand sub-account inventory caps based upon request parameters
         * @summary Get supply/demand sub-account inventory caps
         * @param {SupplyDemandSubAccountInventoryCapApiGetSupplyDemandSubAccountInventoryCapsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyDemandSubAccountInventoryCaps: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getSupplyDemandSubAccountInventoryCaps(requestParameters.id, requestParameters.supplySubAccountId, requestParameters.demandSubAccountId, requestParameters.capType, requestParameters.currentDate, requestParameters.productType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update a supply/demand sub-account inventory cap
         * @summary Update a supply/demand sub-account inventory cap
         * @param {SupplyDemandSubAccountInventoryCapApiUpdateSupplyDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplyDemandSubAccountInventoryCap: function (requestParameters, options) {
            return localVarFp.updateSupplyDemandSubAccountInventoryCap(requestParameters.id, requestParameters.supplyDemandSubAccountInventoryCapUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupplyDemandSubAccountInventoryCapApiFactory = SupplyDemandSubAccountInventoryCapApiFactory;
/**
 * SupplyDemandSubAccountInventoryCapApi - object-oriented interface
 * @export
 * @class SupplyDemandSubAccountInventoryCapApi
 * @extends {BaseAPI}
 */
var SupplyDemandSubAccountInventoryCapApi = /** @class */ (function (_super) {
    __extends(SupplyDemandSubAccountInventoryCapApi, _super);
    function SupplyDemandSubAccountInventoryCapApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create several supply/demand sub-account inventory caps. Respects cap schedule conflicts.
     * @summary Create several supply/demand sub-account inventory caps
     * @param {SupplyDemandSubAccountInventoryCapApiCreateBulkSupplyDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandSubAccountInventoryCapApi
     */
    SupplyDemandSubAccountInventoryCapApi.prototype.createBulkSupplyDemandSubAccountInventoryCap = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplyDemandSubAccountInventoryCapApiFp)(this.configuration).createBulkSupplyDemandSubAccountInventoryCap(requestParameters.supplyDemandSubAccountInventoryCapCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a supply/demand sub-account inventory cap
     * @summary Create a supply/demand sub-account inventory cap
     * @param {SupplyDemandSubAccountInventoryCapApiCreateSupplyDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandSubAccountInventoryCapApi
     */
    SupplyDemandSubAccountInventoryCapApi.prototype.createSupplyDemandSubAccountInventoryCap = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplyDemandSubAccountInventoryCapApiFp)(this.configuration).createSupplyDemandSubAccountInventoryCap(requestParameters.supplyDemandSubAccountInventoryCapCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a supply/demand sub-account inventory cap
     * @summary Delete a supply/demand sub-account inventory cap
     * @param {SupplyDemandSubAccountInventoryCapApiDeleteSupplyDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandSubAccountInventoryCapApi
     */
    SupplyDemandSubAccountInventoryCapApi.prototype.deleteSupplyDemandSubAccountInventoryCap = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyDemandSubAccountInventoryCapApiFp)(this.configuration).deleteSupplyDemandSubAccountInventoryCap(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return a filtered list of sub-account IDs that have not reached cap limit, given a list of sub-account IDs
     * @summary Filter capped sub-account IDs
     * @param {SupplyDemandSubAccountInventoryCapApiFilterSupplyDemandCappedSubAccountIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandSubAccountInventoryCapApi
     */
    SupplyDemandSubAccountInventoryCapApi.prototype.filterSupplyDemandCappedSubAccountIds = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyDemandSubAccountInventoryCapApiFp)(this.configuration).filterSupplyDemandCappedSubAccountIds(requestParameters.limit, requestParameters.demandSubAccountIds, requestParameters.supplySubAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a supply/demand sub-account inventory cap
     * @summary Get a supply/demand sub-account inventory cap
     * @param {SupplyDemandSubAccountInventoryCapApiGetSupplyDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandSubAccountInventoryCapApi
     */
    SupplyDemandSubAccountInventoryCapApi.prototype.getSupplyDemandSubAccountInventoryCap = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyDemandSubAccountInventoryCapApiFp)(this.configuration).getSupplyDemandSubAccountInventoryCap(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return supply/demand sub-account inventory caps based upon request parameters
     * @summary Get supply/demand sub-account inventory caps
     * @param {SupplyDemandSubAccountInventoryCapApiGetSupplyDemandSubAccountInventoryCapsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandSubAccountInventoryCapApi
     */
    SupplyDemandSubAccountInventoryCapApi.prototype.getSupplyDemandSubAccountInventoryCaps = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplyDemandSubAccountInventoryCapApiFp)(this.configuration).getSupplyDemandSubAccountInventoryCaps(requestParameters.id, requestParameters.supplySubAccountId, requestParameters.demandSubAccountId, requestParameters.capType, requestParameters.currentDate, requestParameters.productType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update a supply/demand sub-account inventory cap
     * @summary Update a supply/demand sub-account inventory cap
     * @param {SupplyDemandSubAccountInventoryCapApiUpdateSupplyDemandSubAccountInventoryCapRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyDemandSubAccountInventoryCapApi
     */
    SupplyDemandSubAccountInventoryCapApi.prototype.updateSupplyDemandSubAccountInventoryCap = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyDemandSubAccountInventoryCapApiFp)(this.configuration).updateSupplyDemandSubAccountInventoryCap(requestParameters.id, requestParameters.supplyDemandSubAccountInventoryCapUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupplyDemandSubAccountInventoryCapApi;
}(base_1.BaseAPI));
exports.SupplyDemandSubAccountInventoryCapApi = SupplyDemandSubAccountInventoryCapApi;
